import httpClient, { postJson, postForm } from './HttpClient'

const LOGOUT_TIMEOUT_MS = 5000

export interface LoginResponse {
  msg: string
  type: 'Sucesso' | 'Falha'
}

export interface CaixaAbertaResumo {
  id: number
  nome: string
  idPosto: number
  nomePosto: string
}

export interface SessaoCaixaResumo {
  valorAbertura: number
  terminal: string
  caixa: CaixaAbertaResumo
}

export interface UsuarioAutenticado {
  nome: string
  role: string
  tipo: string
  sessaoCaixa: SessaoCaixaResumo | null
}

const SESSION_FLAG = 'pos_authenticated'

class AuthService {
  private usuarioCache: UsuarioAutenticado | null = null

  async login(telemovel: string, password: string): Promise<LoginResponse> {
    const resultado = await postForm<LoginResponse>('/pos-dexa/login-pos', { telemovel, password })

    if (resultado.type === 'Sucesso') {
      localStorage.setItem(SESSION_FLAG, 'true')
      this.usuarioCache = null
    }

    return resultado
  }

  async logout(): Promise<void> {
    try {
      const controlador = new AbortController()
      const temporizador = setTimeout(() => controlador.abort(), LOGOUT_TIMEOUT_MS)

      await fetch(`${httpClient.baseURL}/pos-dexa/logout`, {
        credentials: 'include',
        signal: controlador.signal
      }).finally(() => clearTimeout(temporizador))
    } catch (erro) {
      // melhor esforço: mesmo que o pedido falhe ou expire, a sessão local é sempre limpa
    }

    localStorage.removeItem(SESSION_FLAG)
    this.usuarioCache = null
  }

  estaAutenticado(): boolean {
    return localStorage.getItem(SESSION_FLAG) === 'true'
  }

  async usuarioAutenticado(forcarRecarga = false): Promise<UsuarioAutenticado | null> {
    if (this.usuarioCache && !forcarRecarga) {
      return this.usuarioCache
    }

    try {
      this.usuarioCache = await postJson<UsuarioAutenticado>('/api/v1/auxiliar/usuario-autenticado')
    } catch {
      this.usuarioCache = null
    }

    return this.usuarioCache
  }

  limparCacheUsuario(): void {
    this.usuarioCache = null
  }
}

export default new AuthService()
